import React from 'react';
import { Modal, View, Text } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import AdminButton from '../AdminButton';
import AdminAlert from '../AdminAlert';
import { ADMIN_COLORS, ADMIN_FONT } from '../../config/theme/adminColors';
import { useResponsive, useModalWidth } from '../../pages/AdminPanel/Products/formStyles';

// Confirmação de exclusão do painel admin.
//
// Usa o `Modal` do react-native (e não o `Dialog`/`Portal` do react-native-paper,
// como o AlertBox): o `Portal.Host` do Paper é criado pelo `<Provider>` que cada
// tela monta localmente, então o diálogo era posicionado dentro do bloco da
// categoria — aparecia no meio DAQUELE bloco, e o backdrop escurecia só ele. O
// `Modal` do RN sobe para a raiz e cobre a viewport inteira, que é o padrão dos
// demais modais do painel (ver TitlePromptModal/CategorySettingsModal).
//
// Além do posicionamento, o modal existe para deixar a exclusão explícita: diz
// QUAL item será apagado (nome em destaque) e avisa que não dá para desfazer.
const ConfirmDeleteModal = ({
  visible,
  title,
  entityLabel,
  entityName,
  description,
  warning = 'Esta ação não pode ser desfeita.',
  confirmLabel = 'Excluir',
  cancelLabel = 'Cancelar',
  isLoading = false,
  onConfirm,
  onCancel,
}) => {
  const { isMobile } = useResponsive();
  const modalWidth = useModalWidth();

  return (
    <Modal
      visible={!!visible}
      transparent
      animationType="fade"
      onRequestClose={onCancel}
    >
      <View
        style={{
          flex: 1,
          backgroundColor: 'rgba(17,24,39,0.45)',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 20,
        }}
      >
        <View
          style={{
            width: modalWidth,
            maxWidth: 480,
            backgroundColor: ADMIN_COLORS.surface,
            borderRadius: 16,
            borderWidth: 1,
            borderColor: ADMIN_COLORS.border,
            padding: 20,
            boxShadow: '0 12px 32px rgba(16,24,40,0.18)',
          }}
        >
          <View
            style={{ flexDirection: 'row', gap: 12, alignItems: 'flex-start' }}
          >
            <View
              style={{
                width: 40,
                height: 40,
                borderRadius: 20,
                backgroundColor: ADMIN_COLORS.dangerSoft,
                borderWidth: 1,
                borderColor: ADMIN_COLORS.dangerBorder,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Ionicons
                name="trash-outline"
                size={20}
                color={ADMIN_COLORS.danger}
              />
            </View>
            <Text
              style={{
                flex: 1,
                fontFamily: ADMIN_FONT,
                fontSize: 18,
                fontWeight: '700',
                color: ADMIN_COLORS.ink,
                lineHeight: 24,
                marginTop: 6,
              }}
            >
              {title}
            </Text>
          </View>

          {entityName ? (
            <View
              style={{
                marginTop: 16,
                padding: 12,
                borderRadius: 10,
                borderWidth: 1,
                borderColor: ADMIN_COLORS.border,
                backgroundColor: ADMIN_COLORS.surfaceSubtle,
              }}
            >
              {entityLabel ? (
                <Text
                  style={{
                    fontFamily: ADMIN_FONT,
                    fontSize: 12,
                    fontWeight: '600',
                    color: ADMIN_COLORS.muted,
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                    marginBottom: 4,
                  }}
                >
                  {entityLabel}
                </Text>
              ) : null}
              <Text
                numberOfLines={2}
                style={{
                  fontFamily: ADMIN_FONT,
                  fontSize: 15,
                  fontWeight: '700',
                  color: ADMIN_COLORS.ink,
                }}
              >
                {entityName}
              </Text>
            </View>
          ) : null}

          {description ? (
            <Text
              style={{
                fontFamily: ADMIN_FONT,
                fontSize: 14,
                color: ADMIN_COLORS.muted,
                lineHeight: 20,
                marginTop: 14,
              }}
            >
              {description}
            </Text>
          ) : null}

          {warning ? (
            <AdminAlert variant="error" icon="warning-outline">
              {warning}
            </AdminAlert>
          ) : null}

          <View
            style={{
              flexDirection: isMobile ? 'column-reverse' : 'row',
              justifyContent: 'flex-end',
              gap: 12,
              marginTop: 20,
            }}
          >
            <AdminButton
              title={cancelLabel}
              variant="secondary"
              onPress={onCancel}
              fullWidth={isMobile}
            />
            <AdminButton
              title={confirmLabel}
              variant="danger"
              icon="trash-outline"
              isLoading={isLoading}
              onPress={onConfirm}
              fullWidth={isMobile}
            />
          </View>
        </View>
      </View>
    </Modal>
  );
};

export default ConfirmDeleteModal;
